"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */

/**
 * Provides a function to check if the browser is online.
 *
 * @module core-online
 *
 * @author Nathan Freeling
 * @copyright 2018 Wells Fargo, All rights reserved.
 */

/**
 * Checks the network connection
 *
 * @return {boolean} a boolean indicating if the browser is online
 */
function isOnline() {
  if (window && window.navigator && typeof window.navigator.onLine === 'boolean') {
    return window.navigator.onLine;
  }

  // default to true so request is sent
  return true;
}
var _default = exports["default"] = {
  isOnline: isOnline
};
//# sourceMappingURL=index.js.map